angular.module('TetherApp').controller('ListViewController', [
    '$scope',
    '$window',
    '$mdDialog',
    '$mdMedia',
    'listService',
    'messageService',
    'participantModalService',
    function (
        $scope,
        $window,
        $mdDialog,
        $mdMedia,
        listService,
        messageService,
        participantModalService
    ) {
        let self = this;

        self.query = '';
        self.pagination = undefined;
        self.current_page = 1;
        self.allParticipants = {};
        self.existingListParticipants = {};
        self.currentListId = undefined;
        self.existingPagination = {};
        self.existingLoadStatus = false;
        self.currentListId = undefined;
        self.loadStatus = false;
        self.isGreaterThanSmall = $mdMedia('gt-sm');

        self.loadExistingParticipants = function (listId, page) {
            if (self.currentListId === undefined) {
                self.currentListId = listId;
            }
            let queryData = {};
            queryData.page = (page === undefined) ? 1 : page;
            listService.getUsersListParticipants(self.currentListId, queryData)
                .then(onExistingParticipants, onError);
        };

        let onExistingParticipants = function (data) {
            self.existingListParticipants = data.data;
            self.existingListParticipants.forEach(function (participant) {
                if (participant.first_name == null) {
                    participant.first_name = '';
                }
                if (participant.last_name == null) {
                    participant.last_name = '';
                }
            });
            let pages = [];
            let firstNumber = ((data.current_page - 2) <= 0) ? 1 : data.current_page - 2;
            let lastNumber = firstNumber + 4;
            if (lastNumber > data.last_page) {
                lastNumber = data.last_page;
            }
            for(let i = firstNumber; i <= lastNumber; i++) {
                pages.push(i);
            }
            self.pagination = {};
            self.pagination.range = pages;
            self.pagination.total = data.total;
            self.pagination.current_page = data.current_page;
            self.pagination.last_page = data.last_page;
            self.pagination.next_page_url = data.next_page_url;
            self.pagination.prev_page_url = data.prev_page_url;
            self.pagination.from = data.from;
            self.pagination.to = data.to;
            self.loadStatus = true;
        };

        let onError = function() {
            self.error = 'Could not fetch the data.';
        };

        self.conversationPopup = function (ev, participant, parentController) {
            self.participant = participant;
            self.isDataLoaded = false;
            self.shortcodeId = $window.shortcode_id;
            DialogController.$inject = ['$mdDialog'];
            $mdDialog.show({
                controller: DialogController,
                controllerAs: 'conversationPopup',
                bindToController: true,
                templateUrl: '/list/partials/conversation-pop-up',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                escapeToClose: true,
                onComplete: self.scrollToBottom
            })
                .then(
                    function () {
                        viewMemberPopupCallback(
                            parentController.viewMemberPopupEvent,
                            parentController.currentList,
                            parentController.viewMemberPopupCallback
                        );
                    },
                    function () {
                        viewMemberPopupCallback(
                            parentController.viewMemberPopupEvent,
                            parentController.currentList,
                            parentController.viewMemberPopupCallback
                        );
                    }
                );
        };

        self.messagePopup = function (ev, participant, parentController) {
            self.participant = participant;
            self.shortcodeId = $window.shortcode_id;
            DialogController.$inject = ['$mdDialog'];
            $mdDialog.show({
                controller: DialogController,
                controllerAs: 'messagePopup',
                bindToController: true,
                templateUrl: '/list/partials/message-pop-up',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                escapeToClose: true
            })
                .then(
                    function () {
                        viewMemberPopupCallback(
                            parentController.viewMemberPopupEvent,
                            parentController.currentList,
                            parentController.viewMemberPopupCallback
                        );
                    },
                    function () {
                        viewMemberPopupCallback(
                            parentController.viewMemberPopupEvent,
                            parentController.currentList,
                            parentController.viewMemberPopupCallback
                        );
                    }
                );
        };

        self.participantPopup = function (ev, participant, parentController) {
            participantModalService
                .getParticipantModal(ev, participant.participant_id)
                .then(
                    function () {
                        viewMemberPopupCallback(
                            parentController.viewMemberPopupEvent,
                            parentController.currentList,
                            parentController.viewMemberPopupCallback
                        );
                    },
                    function () {
                        viewMemberPopupCallback(
                            parentController.viewMemberPopupEvent,
                            parentController.currentList,
                            parentController.viewMemberPopupCallback
                        );
                    }
                );
        };

        let onParticipant = function (data) {
            self.participantData = data;
        };

        let viewMemberPopupCallback = function (ev, list, callback) {
            if (callback !== undefined) {
                callback(ev, list, callback);
            }
        };

        self.getParticipantMessages = function (page, participantId, shortcodeId) {
            messageService.getParticipantMessages(page, participantId, shortcodeId)
                .then(onParticipantMessages, onError);
        };

        let onParticipantMessages = function (data) {
            self.participantMessages = data.data;
            self.isDataLoaded = true;
        };

        self.scrollToBottom = function(){
            $(function() {
                $(".messageLogs").animate({scrollTop: $(".messageLogs")[0].scrollHeight},600);
            });
        };

        let DialogController = function ($mdDialog) {
            let dCtrl = this;
            dCtrl.parent = self;
            dCtrl.message = undefined;

            dCtrl.hide = function () { $mdDialog.hide(); };

            dCtrl.cancel = function () { $mdDialog.cancel(); };

            dCtrl.sendMessage = function() {
                if (dCtrl.message !== undefined) {
                    messageService.send({
                        type: 'sms',
                        participant_id: dCtrl.parent.participant.participant_id,
                        shortcode_id: $window.shortcode_id,
                        message: dCtrl.message
                    }).then(onSend, onError);
                }
            };

            dCtrl.updateSmsCounts = function() {
                dCtrl.message_length = dCtrl.message.length;
                dCtrl.message_count = Math.ceil(dCtrl.message_length / dCtrl.sms_character_limit);
            };

            let onSend = function () { dCtrl.cancel(); };

            let onError = function (data) {};
        };

        $scope.cancel = function() {
            $scope.$parent.cancel();
        };

        self.openMenu = function($mdOpenMenu, ev) {
            originatorEv = ev;
            $mdOpenMenu(ev);
        };
    }
]);
